import React, {useState} from "react";
import {Handle, NodeProps, Position} from "reactflow";
import {SmartTriggerProcessorData, SmartTriggerProcessorNodeConfiguration} from "../../../../types";
import {
    SmartTriggerProcessorSpotlight,
    SmartTriggerProcessorSpotLightPayload
} from "../../../spotlights/smartTriggerProcessorSpotlight";
import {AddProcessorsMenu} from "./addProcessorsMenu";
import {
    SmartTriggerProcessorConfigurationAction,
    SmartTriggerProcessorConfigurationModal
} from "../../../processorConfiguration/smartTriggerProcessorConfigurationModal";
import {RepositoryProcessorData, useSmartTriggerRepository} from "../../../../context/smartTriggerRepositoryProvider";
import {useSmartTriggerConfiguration} from "../../../../context/smartTriggerConfigurationProvider";
import {v4 as uuidv4} from "uuid";


export default function AddProcessorNodeComponent(props: NodeProps<SmartTriggerProcessorData>) {

    const [newConfigurationModalOpened, setNewConfigurationModalOpened] = useState(false);

    const [smartTriggerProcessorConfigurationAction, setSmartTriggerProcessorConfigurationAction] = useState<SmartTriggerProcessorConfigurationAction>({
        type: "new",
        previous: "",
        next: ""
    });

    let smartTriggerRepository = useSmartTriggerRepository();

    let smartTriggerConfiguration = useSmartTriggerConfiguration();

    function onTrigger(actionPayload: SmartTriggerProcessorSpotLightPayload) {
        if (actionPayload.action === 'new') {
            setSmartTriggerProcessorConfigurationAction({
                type: "new",
                previous: props.data.previous as string,
                next: props.id
            })
            setNewConfigurationModalOpened(true);
            return;
        }
        if (actionPayload.action === "pull") {
            const processorFromRepo = smartTriggerRepository.processors.find(processor => processor.id === actionPayload.payload.processorRepositoryId) as RepositoryProcessorData
            const s: SmartTriggerProcessorNodeConfiguration = {
                id: uuidv4(),
                type: 'script',
                position: {
                    x: 0,
                    y: 0
                },
                data: {
                    name: processorFromRepo.name,
                    description: processorFromRepo.description,
                    previous: props.data.previous,
                    next: props.id,
                    author: processorFromRepo.author,
                    script: processorFromRepo.script,
                    implementation: processorFromRepo.implementation,
                    inputs: processorFromRepo.inputs
                }
            }

            smartTriggerConfiguration.addNewProcessor(s)

            // setSmartTriggerProcessorConfigurationAction({
            //     type: "pull",
            //     processorRepositoryId: actionPayload.payload.processorRepositoryId as string,
            //     previous: props.data.previous as string,
            //     next: props.id
            // })
        }
    }


    return (
        <>
            <div>
                <SmartTriggerProcessorSpotlight previousProcessorId={props.data.previous as string}
                                                nextProcessorId={props.id}
                                                onTrigger={onTrigger}
                                                type={'PROCESSOR'}>
                    <AddProcessorsMenu {...props}/>
                </SmartTriggerProcessorSpotlight>
            </div>
            {
                newConfigurationModalOpened &&
                <SmartTriggerProcessorConfigurationModal action={smartTriggerProcessorConfigurationAction}
                                                         isOpened={newConfigurationModalOpened}
                                                         onClose={() => setNewConfigurationModalOpened(false)}/>
            }

            <Handle type="target" position={Position.Top} id="a"/>
        </>
    );
}

